<div class="capa-home">
  <h1 class="titulo">TRÁMITES Y DOCUMENTACIÓN</h1>

  <div
    *ngIf="
      aDatos != null && aDatos != undefined && aDatos.length > 0;
      then tramites;
      else sintramites
    "
  ></div>

  <ng-template #tramites>
    <mat-accordion #acordeon="matAccordion">
      <!-- <mat-expansion-panel *ngFor="let oTramite of aDatos; let i = index;" [expanded]="i === 0" (opened)="panelOpenState = true"> -->
      <mat-expansion-panel
        *ngFor="let oTramite of aDatos; let i = index"
        (opened)="panelOpenState = true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="tramite-titulo">
            {{ oTramite.TRAMITE }}
          </mat-panel-title>
          <mat-panel-description> </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="caja-info1">
          <p>
            <b>{{ oTramite.DTOAREA }}</b>
          </p>
          <p [innerHTML]="oTramite.INFO_AREA"></p>
          <div class="mensaje">
            <p
              *ngIf="oTramite.INFO_TRAMITE !== ''"
              [innerHTML]="oTramite.INFO_TRAMITE"
            ></p>
            <p>Documentación a aportar:</p>
            <ul>
              <li
                class="caja-info-area"
                *ngFor="let oDocumento of oTramite.DOCUMENTOS"
                [innerHTML]="oDocumento.INFO()"
              ></li>
            </ul>
          </div>
        </div>
        <br />
        <div class="btn-grupo">
          <button class="btn-general" (click)="PedirCita(oTramite)">
            <span>Solicitar Cita</span>
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-template>

  <ng-template #sintramites>
    <p style="text-align: center">No hay trámites definidos</p>
  </ng-template>
</div>
